<template>
  <div v-bind:class="flipped ? 'flip-container flipped' : 'flip-container'">
    <div class="flipper">
      <div class="front" @click="open">
        <slot name="front"></slot>
      </div>
      <div class="back">
        <slot name="back" :load="onLoad" :show-opened="showOpened"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cardData", "timeout", "preTimeout", "openable", "onLoad"],
  name: "FlipCard",
  data: function () {
    return {
      flipped: false,
      defaultTimeout: 3000,
      defaultPreTimeout: 5000,
      timer: null,
      freeze: false,
      showOpened: false,
    };
  },
  computed: {
    openableComputed() {
      return this.openable || false;
    },
    timeoutComputed() {
      return this.timeout || this.defaultTimeout;
    },
    preTimeoutComputed() {
      return this.preTimeout || this.defaultPreTimeout;
    },
  },
  watch: {},
  mounted() {
    this.$emit("onMounted", this.cardData.idx);
  },
  methods: {
    setFlip(val, isFreeze = false, hasOpened = null) {
      this.flipped = val;
      if (isFreeze === true) {
        this.lock();
      }
      if (hasOpened != null) {
        this.showOpened = hasOpened;
      }
    },
    show() {
      this.flipped = true;
      this.$nextTick(() => {
        this.timer = setTimeout(() => {
          this.flipped = false;
        }, this.preTimeoutComputed);
      });
    },
    open() {
      // console.log(this.openableComputed);
      if (this.openableComputed === true && this.freeze == false) {
        this.flipped = true;
        this.timer = setTimeout(() => {
          this.close();
        }, this.timeoutComputed);
        this.$emit("onOpen", this.cardData.idx);
      }
    },
    close() {
      if (this.freeze !== true) {
        this.clearTimer();
        this.flipped = false;
        this.$emit("onClose", this.cardData.idx);
      }
    },
    lock() {
      this.clearTimer();
      this.freeze = true;
    },
    unlock() {
      this.freeze = false;
    },
    clearTimer() {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
    },
  },
};
</script>

<style type='text/css' scoped>
.flip-container {
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  perspective: 1000;
}
.flip-container {
  /* min-height: 120px; */
}
.flipper {
  -moz-transform: perspective(1000px);
  -moz-transform-style: preserve-3d;
  /* transform-style: preserve-3d; */
  position: relative;
}
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.5s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.5s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.5s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.5s;
  -ms-transform-style: preserve-3d;
  transition: 0.5s;
  transform-style: preserve-3d;
  /* top: 0;
  left: 0; */
  width: 100%;
}
.back {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  position: absolute;
  top: 0;
  left: 0;
}
.flip-container.flipped .back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.flip-container.flipped .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.front {
  z-index: 2;
}
</style>